import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import '../styles/blah.less';
import '../styles/emoji.less';
import '../styles/tailwind.out.css';
import { routes } from './routes/routes';
import RouteWithSubRoutes from './route_with_sub_routes/RouteWithSubRoutes';
import { Badge, Modal, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import {
	LockOutlined,
	LogoutOutlined,
	SettingOutlined,
	SwapOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Dropdown, Layout, Menu, Button, Tooltip, Row, Col } from 'antd';
import { withRouter, Switch, Route } from 'react-router';
import {
	changeWorkspace,
	logOut,
	resendConfirmation,
	searchWorkspaces,
} from '../thunks/session_thunks';
import {
	getMenuItemsByRole,
	getWSSBackendUri,
	SidebarNavMenuIconConfig,
} from '../utils/EnvConfigUtils';
import NotFoundPage from './not_found_page/NotFoundPage';
import { PageLoadingPlaceholder } from './page_loading_placeholder/PageLoadingPlaceholder';
import { ContactAvatar } from './contact_avatar/ContactAvatar';
import { checkAuthorization, checkCompanyPermission } from './roles/roles';
import { enquireScreen } from '../utils/ResponsiveUtils';
import { nullSafeGet, nullSafeGetOrElse, sortItemsWithLockedAtEnd } from '../utils/DataAccessUtils';

import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../thunks/user_notifications_thunks';
import { ROLE_TYPES, SALES_LEAD_FORM_URL } from '../utils/DataConstants';

import amplitude from 'amplitude-js';
import { AmplitudeProvider } from '@amplitude/react-amplitude';
import Cohere from 'cohere-js';
import IntercomService from '../utils/IntercomService';
import OfflineHandler from './OfflineHandler';
import WorkspacesHoc from './workspace_hoc';
import SwitchWorkspaceModal from './workspaces_switch_modal';
import posthog from 'posthog-js';
import { withAuth0 } from '@auth0/auth0-react';
import ChangePasswordModal from './change_password_modal/ChangePasswordModal';
import G2ReviewPrompt from './g2_review_prompt/G2ReviewPrompt';
import { CONFIG_NAMES, isUserAllowedToAccess, isUserManagedBySupplier } from '../utils/AuthUtils';
import { isSupplierInventoryConfigEnabled } from './common/SupplierInventoryConfigPermissionChecker';
import { UNREAD_NOTIFICATION_TYPES } from '../utils/NotificationUtils';
import TitleWithLock from './common/TitleWithLock';
import ScrollManager from './scroll_component/ScrollComponent';
import { WebSocketProvider } from '../context/WebSocketProvider';
import { Helmet } from 'react-helmet';
import VersionUpdateBanner from './version_update_banner/VersionUpdateBanner';
import OscarDock from '../ai_agent/components/oscar_dock/OscarDock';
import OscarBetaBanner from '../ai_agent/components/oscar_beta_banner/OscarBetaBanner';
import { clearStoredConversation } from '../ai_agent/utils/OscarConversationStorage';
import { agentLogout } from '../thunks/agent_harness_thunks';
import { initializeVersion } from '../utils/VersionUtils';
import { MAIN_SLIDER_MENU_ID } from '../utils/DomUtils';
import { cn } from '../utils/ClassNamesUtils';
import DuplicateWorkOrdersStopped from './duplicate_work_orders_stopped/DuplicateWorkOrdersStopped';

const { Text } = Typography;
const AMPLITUDE_KEY = 'e375307b092b3f16ce11c42e38063d02';

require('../styles/icons8-styles.less');

const Content = Layout.Content;
const Sider = Layout.Sider;

require('lodash');
const Color = require('color');

const transparentHeaderLocations = [
	'buyer/login',
	'supplier/login',
	'buyer/signup',
	'supplier/signup',
	'buyer/forgotPassword',
	'supplier/forgotPassword',
	'public/suppliers/detail',
	'search',
	'writeAReview',
];

const menuLightModeLocations = [
	'solutions/work-order-management',
	'solutions/asset-management',
	'solutions/contractor-management',
	'solutions/planned-maintenance',
	'solutions/analytics',
	'contact-us',
];

const SIDER_MENU_SVG_ICON_CLASSNAME =
	'!relative !top-[3px] !mr-8 h-5 w-5 flex-shrink-0 text-inherit';

function renderSiderMenuIcon(
	menuItemStyle: React.CSSProperties,
	item: SidebarNavMenuIconConfig
): React.ReactElement | null {
	if (item.menuSvgIcon) {
		const SvgIcon = item.menuSvgIcon;
		const nudgeStyle: React.CSSProperties = {};
		if (menuItemStyle.left !== undefined) {
			nudgeStyle.left = menuItemStyle.left;
		}
		return (
			<SvgIcon
				className={SIDER_MENU_SVG_ICON_CLASSNAME}
				style={Object.keys(nudgeStyle).length ? nudgeStyle : undefined}
				aria-hidden
				focusable="false"
			/>
		);
	}
	if (item.icon) {
		return <i style={menuItemStyle} className={item.icon} />;
	}
	return null;
}

interface AppState {
	collapsed: boolean;
	menuMode: string;
	isModalVisible: boolean;
}

class App extends React.Component<any, AppState> {
	notificationSocket: WebSocket;
	/*eslint-disable */

	heartbeat?: NodeJS.Timeout;
	_isLoggedIn = false;

	layoutRef = React.createRef<HTMLDivElement>();
	siderResizeObserver?: ResizeObserver;

	/*eslint-enable */

	constructor(props) {
		super(props);

		this.state = {
			collapsed: false,
			menuMode: 'desktop',
			isModalVisible: false,
		};
		Cohere.init('m2RcRCMfxRMTZW3Q63gSyHdr');
		this.onCollapse = this.onCollapse.bind(this);
		this.onUserMenuClick = this.onUserMenuClick.bind(this);
		this.onMobileMenuClick = this.onMobileMenuClick.bind(this);
		this.handleNoticeClear = this.handleNoticeClear.bind(this);
		this.checkActiveRoute = this.checkActiveRoute.bind(this);
		this.hideModal = this.hideModal.bind(this);
	}

	establishWebSocketConnection = (email, token) =>
		new WebSocket(
			`${getWSSBackendUri()}/api/v1/${this.props.userType}/websocket/notification/${email}/${token}`
		);

	notificationOnClick = (notificationJSON) => {
		const { updateUserNotificationForBuyer, updateUserNotificationForSupplier, userType, history } =
			this.props;
		const appDomainRegex =
			userType === ROLE_TYPES.BUYER
				? /https:\/\/app\.useopenwrench\.com(.+)/i
				: /https:\/\/partners\.useopenwrench\.com(.+)/i;
		const notificationCapture = nullSafeGet(
			'webAppUrl',
			notificationJSON[`${userType}PushNotification`]
		).match(appDomainRegex);
		const notificationUrl = notificationCapture[1];
		const updateUserNotification =
			userType === ROLE_TYPES.BUYER
				? updateUserNotificationForBuyer
				: updateUserNotificationForSupplier;
		const newNotification = {
			...notificationJSON,
			hasSeen: true,
		};
		updateUserNotification(newNotification);
		history.push(notificationUrl);
	};

	refreshNotifications = () => {
		const {
			fetchUserNotificationsCountForBuyer,
			fetchUserNotificationsCountForSupplier,
			userType,
		} = this.props;

		const fetchUserNotificationsCount =
			userType === ROLE_TYPES.BUYER
				? fetchUserNotificationsCountForBuyer
				: fetchUserNotificationsCountForSupplier;
		fetchUserNotificationsCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
	};

	webSocketLifeCycle = () => {
		// disabling notifications
		return null;
	};

	socketSend = (JSONString, retries = 3) => {
		if (this.notificationSocket.readyState === 1) {
			this.notificationSocket.send(JSONString);
		} else {
			if (retries > 0) {
				console.log('Notification Socket Send :: Retry ::', retries);
				// this.webSocketLifeCycle();
				this.socketSend(JSONString, retries - 1);
			} else {
				console.log('Notification not sent', JSONString);
			}
		}
	};

	componentDidMount() {
		this._isLoggedIn = true;
		const { isAuthenticated, history } = this.props;
		enquireScreen((b) => {
			this.setState({ menuMode: b ? 'mobile' : 'desktop' });
		});

		if (isAuthenticated) {
			this.refreshNotifications();
			this.setupNoteInputPositioning();
		}
		IntercomService.init();

		// Initialize version tracking for update detection
		initializeVersion();

		function trackPageView() {
			posthog.capture('$pageview');
		}

		history.listen(trackPageView);
		history.listen(() => {
			Modal.destroyAll();
		});
	}

	componentDidUpdate(prevProps) {
		this._isLoggedIn = true;
		const { isAuthenticated } = this.props;

		if (isAuthenticated !== prevProps.isAuthenticated) {
			if (isAuthenticated) {
				this.refreshNotifications();
			} else if (this.siderResizeObserver) {
				// User logged out — disconnect so the observer is re-set up on next login
				this.siderResizeObserver.disconnect();
				this.siderResizeObserver = undefined;
			}
		}
		this.setupNoteInputPositioning();
	}

	atLogOutActions = (userType) => {
		this._isLoggedIn = false;
		if (this.heartbeat) clearInterval(this.heartbeat);
		this.notificationSocket && this.notificationSocket.close();
		// history.push(`/${userType}/login`);
	};

	componentWillUnmount() {
		const { userType } = this.props;
		this.atLogOutActions(userType);
		if (this.siderResizeObserver) this.siderResizeObserver.disconnect();
	}

	onCollapse() {
		this.setState({ collapsed: !this.state.collapsed });
	}

	onUserMenuClick({ key }) {
		const {
			userType,
			logOut,
			history,
			auth0: { logout: Auth0logout },
			currentUser,
		} = this.props;
		switch (key) {
			case 'changePassword':
				history.push(`/${userType}/changePassword`);
				return true;
			case 'logout':
				// End the agent session too. Its cookie has no Max-Age and outlives an
				// OpenWrench sign-out, and each live session holds one of the harness's
				// slots (MAX_SESSIONS, 10 by default) for SESSION_TTL_MS.
				// Best effort: a failure here must not block signing out.
				this.props.agentLogout().catch(() => undefined);
				clearStoredConversation();
				logOut(userType).then((res) => {
					if (currentUser.isSSOUser) {
						Auth0logout({
							logoutParams: {
								federated: true,
								returnTo: `${window.location.origin}/${userType}/login`,
							},
						});
					}
					this.atLogOutActions(userType);
				});
				return true;
			case 'login':
				history.push('/login');
				return true;
			case 'profile':
				history.push(`/${userType}/myProfile`);
				return true;
			case 'settings':
				history.push(`/${userType}/settings`);
				return true;
			case 'signup':
				history.push('/signup');
				return true;
			case 'workspaces':
				this.setState({ isModalVisible: true });
				return true;
			default:
				return true;
		}
	}

	hideModal() {
		this.setState({ isModalVisible: false });
	}

	onMobileMenuClick({ key }) {
		const { history } = this.props;
		switch (key) {
			case 'signUpAsSupplier':
				history.push('/supplier/signup');
				return true;
			case 'signUpAsBuyer':
				history.push('/buyer/signup');
				return true;
			case 'healthcare':
				history.push('/health');
				return true;
			case 'cre':
				history.push('/cre');
				return true;
			case 'blog':
				history.push(`/blog`);
				return true;
			default:
				return true;
		}
	}

	getMenuSelectedKeys() {
		const { location } = this.props;
		const pathname = location.pathname;
		// TODO: these should not be hard coded. refactor menu to work off a list.
		const keys = ['/dashboard', '/sourcing', '/analytics', '/contracts', '/projects'];
		return keys.filter((key) => pathname.indexOf(key) !== -1);
	}

	handleNoticeClear() {}

	handleNoticeVisibleChange() {}

	resendConfirmation = () => {
		const { userType, resendConfirmation } = this.props;
		resendConfirmation(userType);
	};

	setupNoteInputPositioning = () => {
		if (this.siderResizeObserver) return;
		const sliderEl = document.getElementById(MAIN_SLIDER_MENU_ID);
		if (!sliderEl) return;

		const updateSliderWidth = () => {
			document.documentElement.style.setProperty('--slider-width', `${sliderEl.offsetWidth}px`);
		};

		this.siderResizeObserver = new ResizeObserver(updateSliderWidth);
		this.siderResizeObserver.observe(sliderEl);
	};

	checkActiveRoute(route) {
		const { location } = this.props;
		let regex = new RegExp(route);
		return regex.test(location.pathname);
	}

	checkActiveRoutes(routeArray: string[]) {
		return routeArray.some((route) => this.checkActiveRoute(route));
	}

	getLinkClasses = (route) => {
		let linkClasses = ['linkItem'];
		let isActive = false;
		let isLightMode = this.checkMenuLightMode();
		if (Array.isArray(route)) {
			isActive = this.checkActiveRoutes(route);
		} else {
			isActive = this.checkActiveRoute(route);
		}
		if (isActive) {
			linkClasses.push('linkItem--active');
		}
		if (isLightMode) {
			linkClasses.push('linkItem--lightMode');
		}
		return linkClasses.join(' ');
	};

	checkMenuLightMode() {
		const { location } = this.props;
		return menuLightModeLocations.some((loc) => {
			let regex = new RegExp(loc);
			return regex.test(location.pathname);
		});
	}

	render() {
		const {
			authChecked,
			backlinkTo,
			backlinkTitle,
			history,
			navbarBackgroundColor,
			companyConfig,
			isAuthenticated,
			location,
			currentUser,
			userType,
			activeWorkspaceId,
			featureFlags,
		} = this.props;
		const { collapsed } = this.state;

		const pathname = location.pathname;

		let menuItemStyle;
		if (collapsed) {
			menuItemStyle = {
				position: 'relative',
				fontSize: 28,
				left: -6,
			};
		} else {
			menuItemStyle = { fontSize: 24 };
		}

		const showTransparentHeader = transparentHeaderLocations.some((loc) => {
			let regex = new RegExp(loc);
			return regex.test(location.pathname);
		});

		let headerStyle = {};
		let headerLogoUrl = '';
		if (showTransparentHeader) {
			headerStyle = {
				padding: '0',
				position: 'absolute',
				height: 64,
				lineHeight: '64px',
				left: 0,
				right: 0,
			};
		} else {
			if (isAuthenticated) {
				headerStyle = {
					padding: '0',
					background: '#3D82AA',
					position: 'relative',
				};
			} else {
				headerStyle = {
					padding: '0',
					height: 64,
					lineHeight: '64px',
					position: 'absolute',
					left: 0,
					right: 0,
				};
			}
		}
		const whiteLogoUrl =
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-logo/openwrenchlogo-white.png';
		const greyLogoUrl =
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-logo/openwrenchlogo-grey.png';

		//These logos are unused in the code. Might be useful in future so commenting it out
		// const colorLogoUrl =
		// 	'https://s3.amazonaws.com/emptor-data-assets/images/emptor-logo/openwrenchlogo.png';
		// const whiteLogoCollapsedUrl =
		// 	'https://s3.amazonaws.com/emptor-data-assets/images/openwrench-logos/openwrenchlogocollapsed-white.png';
		// const colorLogoCollapsedUrl =
		// 	'https://s3.amazonaws.com/mock-data-assets/categories/images/Logo_Coloured_Symbol.png';

		const siderLogoUrl = collapsed
			? nullSafeGet('config.theme.logoMinimized', companyConfig)
			: nullSafeGet('config.theme.logo', companyConfig);
		const getSubnavColor = () => {
			if (navbarBackgroundColor) {
				return navbarBackgroundColor;
			} else if (nullSafeGet('config.theme.navblock', companyConfig)) {
				return Color(nullSafeGet('config.theme.navblock', companyConfig)).darken(0.2).toString();
			} else if (userType === ROLE_TYPES.SUPPLIER) {
				return '#1b4d5a';
			} else {
				return '#351b5a';
			}
		};

		let headerLogoStyle = {};
		if (showTransparentHeader) {
			headerLogoUrl = whiteLogoUrl;
			headerLogoStyle = {
				color: 'white',
			};
		} else {
			headerLogoUrl = greyLogoUrl;
			headerLogoStyle = {
				color: '#1f8ceb',
			};
		}

		const changePWParams = currentUser.isSharedContact
			? {
					tooltip: 'Shared users must logout to reset password',
					disabled: true,
			  }
			: {};
		const userMenu = (currentUser) => {
			let items = [
				{ icon: <UserOutlined />, key: 'profile', label: 'Profile' },

				{ icon: <SettingOutlined />, key: 'settings', label: 'Settings' },
				{ icon: <LogoutOutlined />, key: 'logout', label: 'Log Out' },
			];
			if (
				currentUser.hasAllFacilityAccess ||
				(currentUser.secondaryFacilityIds && currentUser.secondaryFacilityIds.length)
			) {
				items = [
					...items.slice(0, 2),
					{
						icon: <SwapOutlined rotate={90} />,
						key: 'workspaces',
						label: 'Switch Facility',
					},
					...items.slice(2),
				];
			}
			if (!currentUser.isSSOUser) {
				items = [
					...items.slice(0, 1),
					{
						icon: <LockOutlined style={{ fontSize: 12 }} />,
						key: 'changePassword',
						label: 'Change Password',
						...changePWParams,
					},
					...items.slice(1),
				];
			}
			return (
				<Menu mode="inline" selectedKeys={[]} onClick={this.onUserMenuClick}>
					{items.map((item) =>
						nullSafeGet('tooltip', item) ? (
							<Menu.Item key={item.key} disabled={true} style={{ width: 'max-content' }}>
								<Tooltip placement={'left'} trigger={'hover'} title={nullSafeGet('tooltip', item)}>
									<div style={{ display: 'flex', width: '100%', gap: '8px', flexWrap: 'nowrap' }}>
										<div>{item.icon}</div>
										{item.label}
									</div>
								</Tooltip>
							</Menu.Item>
						) : (
							<Menu.Item key={item.key} icon={item.icon} style={{ minWidth: 'max-content' }}>
								{item.label}
							</Menu.Item>
						)
					)}
				</Menu>
			);
		};

		const isManagedBySupplier = isUserManagedBySupplier(currentUser);

		let menuItems = [];
		if (currentUser.roles && userType) {
			let updatedUserType = userType;
			if (
				userType === 'supplier' &&
				nullSafeGetOrElse('facility.status', currentUser, '') === 'private'
			) {
				updatedUserType = 'internal_supplier';
			}

			const disablePO = isSupplierInventoryConfigEnabled(
				companyConfig,
				CONFIG_NAMES.DISABLE_PURCHASE_ORDERS
			);

			menuItems = getMenuItemsByRole(updatedUserType, featureFlags)
				.filter((menuItem) => {
					const hasRoleAuth = checkAuthorization(menuItem.authorizedRoles)(currentUser.roles);
					const hasCompanyAuth = checkCompanyPermission(menuItem.unauthorizedCompanies)(
						userType === ROLE_TYPES.SUPPLIER
							? nullSafeGet('facility.supplierCompanyId', currentUser)
							: nullSafeGet('facility.buyerCompanyId', currentUser)
					);
					const allAccessPermissionNames = menuItem.anyAccessPermissionNames || [
						menuItem.accessPermissionName,
					];
					const hasAccessPermission = allAccessPermissionNames.some((permissionName) =>
						isUserAllowedToAccess(userType)(permissionName, companyConfig, currentUser.roles)
					);
					const hasAccessPermissionBasedOnSupplierManagedAccout =
						!isManagedBySupplier || !menuItem.hiddenIfManagedBySupplier;
					const tobeSeen = menuItem.showInMenu ? menuItem.showInMenu(currentUser) : true;
					return (
						hasRoleAuth &&
						hasCompanyAuth &&
						hasAccessPermission &&
						hasAccessPermissionBasedOnSupplierManagedAccout &&
						tobeSeen
					);
				})
				.map((menuItem) =>
					menuItem.children
						? {
								...menuItem,
								children: sortItemsWithLockedAtEnd(
									menuItem.children.filter((child) => {
										const hasRoleAuth = checkAuthorization(child.authorizedRoles)(
											currentUser.roles
										);
										const hasCompanyAuth = checkCompanyPermission(child.unauthorizedCompanies)(
											userType === 'supplier'
												? nullSafeGet('facility.supplierCompanyId', currentUser)
												: nullSafeGet('facility.buyerCompanyId', currentUser)
										);

										const allAccessPermissionNames = child.anyAccessPermissionNames || [
											child.accessPermissionName,
										];
										const hasAccessPermission = allAccessPermissionNames.some((permissionName) =>
											isUserAllowedToAccess(userType)(
												permissionName,
												companyConfig,
												currentUser.roles
											)
										);
										if (child.to === '/supplier/purchaseOrders' && disablePO) {
											return false;
										}
										const tobeSeen = child.showInMenu ? child.showInMenu(currentUser) : true;
										return hasRoleAuth && hasCompanyAuth && hasAccessPermission && tobeSeen;
									}),
									isManagedBySupplier
								),
						  }
						: menuItem
				);

			menuItems = sortItemsWithLockedAtEnd(menuItems, isManagedBySupplier);
		}

		const SALES_LEAD_FORM_LINK = SALES_LEAD_FORM_URL(currentUser);

		const minimalLayoutRoutes = [
			'/buyer/notifications',
			'/supplier/notifications',
			'/buyer/workorder_notifications',
			'/supplier/workorder_notifications',
			'/buyer/g2-review',
			'/supplier/g2-review',
		];
		const isMinimalLayout = minimalLayoutRoutes.some((route) => pathname.startsWith(route));

		// Fullscreen Oscar drops the sub-navigation bar so the agent owns the
		// whole content area. The left nav stays: per the design, clicking another
		// section is how you leave the agent.
		const isOscarFullScreen = pathname.endsWith('/agent');

		if (!authChecked) {
			return <PageLoadingPlaceholder />;
		}

		if (isMinimalLayout) {
			return (
				<div
					className="flex h-screen items-center justify-center bg-gray-50"
					style={{ flexDirection: 'column' }}
				>
					<Switch>
						{routes.map((r, i) => (
							<RouteWithSubRoutes key={i} {...r} />
						))}
					</Switch>
				</div>
			);
		}

		return (
			<WebSocketProvider userType={userType} featureFlags={featureFlags}>
				<Helmet>
					<title>OpenWrench</title>
				</Helmet>
				{isAuthenticated ? (
					<div className="print:!hidden">
						<VersionUpdateBanner sticky={true} />
					</div>
				) : null}
				{/* Same condition as the top bar that hosts `OscarDock`: its CTA opens the dock. */}
				{isAuthenticated && !isOscarFullScreen ? <OscarBetaBanner /> : null}
				{isAuthenticated && <G2ReviewPrompt />}
				<AmplitudeProvider
					amplitudeInstance={amplitude.getInstance()}
					apiKey={AMPLITUDE_KEY}
					userId={currentUser.email}
					key={currentUser.email}
				>
					<Layout
						id="layoutDiv"
						className="layout hide-horizontal-scrollbar print:!h-auto print:!min-h-0 print:!overflow-visible"
						ref={this.layoutRef}
					>
						<ScrollManager
							history={history}
							redirect={this.props.redirectRef}
							layout={this.layoutRef}
						/>
						{isAuthenticated ? (
							<Sider
								id={MAIN_SLIDER_MENU_ID}
								className="print:!hidden"
								collapsible={true}
								collapsed={collapsed}
								onCollapse={this.onCollapse}
								breakpoint="lg"
								width={256}
								style={{
									minHeight: '100vh',
									background: nullSafeGet('config.theme.sidebar', companyConfig),
								}}
							>
								<Link to="/">
									<div style={{ padding: collapsed ? '0 20px' : '0px 56px 0 24px' }}>
										<div
											className="siderLogoContainer"
											style={{ backgroundImage: `url(${siderLogoUrl})` }}
										/>
									</div>
								</Link>
								<Menu
									style={{
										background: nullSafeGet('config.theme.sidebar', companyConfig),
										marginTop: 24,
									}}
									theme="dark"
									selectedKeys={this.getMenuSelectedKeys()}
									mode="inline"
								>
									{menuItems.map((item, i) => {
										const isLocked = item.lockedIfManagedBySupplier && isManagedBySupplier;
										const popoverContent =
											'Contact support@useopenwrench.com to access this feature';
										return item.children ? (
											<Menu.SubMenu
												key={i}
												disabled={isLocked}
												title={
													<TitleWithLock
														containerClassName="ant-submenu-item"
														icon={renderSiderMenuIcon(menuItemStyle, item)}
														className="nav-text"
														isLocked={isLocked}
													>
														{item.title}
													</TitleWithLock>
												}
											>
												{item.children.map((child) => {
													const isChildLocked =
														child.lockedIfManagedBySupplier && isManagedBySupplier;
													return isChildLocked ? (
														<Tooltip
															key={child.to}
															color="white"
															title={
																<a href={SALES_LEAD_FORM_LINK} target="_blank" rel="noopener">
																	Get access <ArrowRightOutlined />
																</a>
															}
														>
															<div style={{ paddingLeft: '48px' }}>
																<Menu.Item
																	className={
																		child.checkActive(pathname) ? 'siderMenuItemActive' : ''
																	}
																	disabled={isChildLocked}
																	key={child.to}
																	style={{ paddingLeft: '0px' }}
																>
																	<Link
																		className={`flex items-baseline justify-between ${
																			child.checkActive(pathname) ? 'siderMenuLinkActive' : ''
																		}`}
																		to={child.to}
																	>
																		<TitleWithLock
																			icon={renderSiderMenuIcon(menuItemStyle, child)}
																			className="nav-text"
																			isLocked={isChildLocked}
																		>
																			{child.title}
																		</TitleWithLock>
																		{(child.count && (
																			<Badge
																				className="ml-2"
																				size="small"
																				count={child.count(this.props)}
																			/>
																		)) ||
																			null}
																	</Link>
																</Menu.Item>
															</div>
														</Tooltip>
													) : (
														<Menu.Item
															key={child.to}
															className={child.checkActive(pathname) ? 'siderMenuItemActive' : ''}
														>
															<Link
																className={`flex items-baseline justify-between ${
																	child.checkActive(pathname) ? 'siderMenuLinkActive' : ''
																}`}
																to={child.to}
															>
																<TitleWithLock
																	icon={renderSiderMenuIcon(menuItemStyle, child)}
																	className={cn(
																		'nav-text',
																		child.menuSvgIcon && collapsed ? 'relative -left-8' : ''
																	)}
																	isLocked={isChildLocked}
																>
																	{child.title}
																</TitleWithLock>
																{(child.count && (
																	<Badge
																		className="ml-2"
																		size="small"
																		count={child.count(this.props)}
																	/>
																)) ||
																	null}
															</Link>
														</Menu.Item>
													);
												})}
											</Menu.SubMenu>
										) : isLocked ? (
											<Tooltip
												color="white"
												title={
													<a href={SALES_LEAD_FORM_LINK} target="_blank" rel="noopener ">
														Get access <ArrowRightOutlined size={12} />
													</a>
												}
											>
												<div style={{ paddingLeft: '24px' }}>
													<Menu.Item
														className={item.checkActive(pathname) ? 'siderMenuItemActive' : ''}
														disabled={isLocked}
														key={item.to}
														style={{ paddingLeft: '0px' }}
													>
														<Link
															className={`flex items-baseline justify-between ${
																item.checkActive(pathname) ? 'siderMenuLinkActive' : ''
															}`}
															to={item.to}
														>
															<TitleWithLock
																icon={renderSiderMenuIcon(menuItemStyle, item)}
																className="nav-text"
																isLocked={isLocked}
															>
																{item.title}
															</TitleWithLock>
															{(item.count && (
																<Badge
																	className="ml-2"
																	size="default"
																	count={item.count(this.props)}
																/>
															)) ||
																null}
														</Link>
													</Menu.Item>
												</div>
											</Tooltip>
										) : (
											<Menu.Item
												className={item.checkActive(pathname) ? 'siderMenuItemActive' : ''}
												key={item.to}
											>
												<Link
													className={`flex items-baseline justify-between ${
														item.checkActive(pathname) ? 'siderMenuLinkActive' : ''
													}`}
													to={item.to}
												>
													<TitleWithLock
														icon={renderSiderMenuIcon(menuItemStyle, item)}
														className="nav-text"
														isLocked={isLocked}
													>
														{item.title}
													</TitleWithLock>
													{(item.count && (
														<Badge className="ml-2" size="default" count={item.count(this.props)} />
													)) ||
														null}
												</Link>
											</Menu.Item>
										);
									})}
								</Menu>
							</Sider>
						) : null}
						<Layout className="print:!ml-0 print:!h-auto print:!min-h-0 print:!overflow-visible">
							<Content className="print:!m-0 print:!max-h-none print:!min-h-0 print:!overflow-visible print:!p-0">
								<ChangePasswordModal currentUser={currentUser} />
								{isAuthenticated && !isOscarFullScreen ? (
									<div
										className="app-content-topbar print:!hidden"
										style={{
											height: 40,
											backgroundColor: getSubnavColor(),
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
									>
										<div style={{ marginLeft: 26 }}>
											{backlinkTo ? (
												<Link
													to={{
														pathname: backlinkTo.split('?')[0],
														search: backlinkTo.includes('?')
															? backlinkTo.substring(backlinkTo.indexOf('?'))
															: '',
														state: { fromBackLink: true },
													}}
												>
													<Button
														style={{
															display: 'flex',
															alignItems: 'center',
															color: 'white',
														}}
														type="link"
													>
														<i
															style={{ fontSize: 20, marginRight: 8 }}
															className={`icons8-font icons8-long-arrow-left`}
														/>
														<span>{backlinkTitle}</span>
													</Button>
												</Link>
											) : null}
										</div>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
										>
											<DuplicateWorkOrdersStopped />
											<Tooltip placement="bottom" title="Refer a Friend">
												<Button
													onClick={() => history.push(`/${userType}/referral`)}
													key="feedback"
													type="link"
													style={{ paddingTop: 0 }}
												>
													<i
														style={{ fontSize: 24, color: 'white' }}
														className={`icons8-get-cash`}
													/>
												</Button>
											</Tooltip>
											<Tooltip placement="bottom" title="Request a Feature">
												<Button key="feedback" type="link" style={{ paddingTop: 0 }}>
													<a
														href="https://openwrench.canny.io/feature-requests"
														target="_blank"
														rel="noreferrer"
													>
														<i
															style={{ fontSize: 24, color: 'white' }}
															className={`icons8-fantasy`}
														/>
													</a>
												</Button>
											</Tooltip>
											<Tooltip placement="bottom" title="Report a Bug">
												<Button key="feedback" type="link" style={{ paddingTop: 0 }}>
													<a
														href="https://openwrench.canny.io/bugs"
														target="_blank"
														rel="noreferrer"
													>
														<i
															style={{ fontSize: 24, color: 'white' }}
															className={`icons8-bug-2`}
														/>
													</a>
												</Button>
											</Tooltip>
											<Tooltip placement="bottom" title="Chat with Support">
												<Button
													key="help"
													type="link"
													style={{ paddingTop: 0 }}
													onClick={() => {
														//@ts-ignore;
														window.Intercom('show');
													}}
												>
													<i
														style={{ fontSize: 24, color: 'white' }}
														className={`icons8-headset`}
													/>
												</Button>
											</Tooltip>
											<div style={{ margin: '0 16px' }}>
												<Dropdown placement="bottomLeft" overlay={userMenu(currentUser)}>
													<Row align="middle">
														<Col>
															<ContactAvatar
																hidePopover={true}
																contact={currentUser}
																userType={userType}
															/>
														</Col>
														{((currentUser.hasAllFacilityAccess ||
															(currentUser.secondaryFacilityIds &&
																currentUser.secondaryFacilityIds.length)) && (
															<Col style={{ color: 'white', marginLeft: 12 }}>
																<Row style={{ flexDirection: 'column' }}>
																	<Text style={{ color: 'white' }}>{currentUser.email}</Text>
																	<span
																		style={{
																			color: 'white',
																			opacity: 0.8,
																			lineHeight: 1,
																			fontSize: 12,
																		}}
																	>
																		{nullSafeGet('facility.displayName', currentUser)}
																	</span>
																</Row>
															</Col>
														)) ||
															null}
													</Row>
												</Dropdown>
												<Modal
													footer={
														<Row justify="space-between">
															<Link to={`/${userType}/newFacilitySetup`}>
																<Button onClick={this.hideModal} type="default">
																	Create new
																</Button>
															</Link>

															<Button onClick={this.hideModal} type="primary">
																Cancel
															</Button>
														</Row>
													}
													centered
													bodyStyle={{ maxHeight: '60vh', overflow: 'auto' }}
													onCancel={this.hideModal}
													visible={this.state.isModalVisible}
												>
													<SwitchWorkspaceModal
														userType={userType}
														workspaces={currentUser.secondaryFacilities}
														activeWorkspaceId={activeWorkspaceId}
														changeWorkspace={this.props.changeWorkspace}
														searchWorkspaces={this.props.searchWorkspaces}
														currentUser={currentUser}
													/>
												</Modal>
											</div>
											{/* Renders nothing here: its edge tab and drawer are portalled to
											    <body>. Mounted in the top bar so it shares its visibility. */}
											<OscarDock userName={nullSafeGetOrElse('nameGiven', currentUser, 'there')} />
										</div>
									</div>
								) : null}
								<Switch>
									{routes.map((r, i) => (
										<RouteWithSubRoutes key={i} {...r} />
									))}
									<Route component={NotFoundPage} />
								</Switch>
							</Content>
						</Layout>
					</Layout>
				</AmplitudeProvider>
			</WebSocketProvider>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	isAuthenticated: state.session.isAuthenticated,
	activeWorkspaceId: state.session.workspaceId,
	authChecked: state.session.initialCheck,
	accountActivated: state.session.accountActivated,
	companyConfig: state.company_config.detail,

	currentUser: state.session.currentUser,
	userType: state.session.userType,
	backlinkTo: state.navbar.backlinkTo,
	backlinkTitle: state.navbar.backlinkTitle,
	navbarBackgroundColor: state.navbar.navbarBackgroundColor,
	location: ownProps.location,
	featureFlags: state.session.featureFlags,
	userNotifications: state.user_notifications,
});

const mapDispatchToProps = (dispatch) => ({
	resendConfirmation: (role) => dispatch(resendConfirmation(role)()),
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
	updateUserNotificationForBuyer: (entity) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.update(entity)),
	updateUserNotificationForSupplier: (entity) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.update(entity)),
	logOut: (role) => dispatch(logOut(role)()),
	agentLogout: () => dispatch(agentLogout()),
	changeWorkspace: (id, userType) => dispatch(changeWorkspace(id, userType)),
	searchWorkspaces: (str, userType, page) => dispatch(searchWorkspaces(str, userType, page)),
});

const ComponentWithoutUserType = withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(OfflineHandler(WorkspacesHoc(withAuth0(App))))
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
